<div class="row top-content-row">
  <div class="container">
    <div class="form-horizontal">
      <h1 class="heading">Template Settings</h1>
    </div>
  </div>

  <div class="container">
    <form
      class="form-horizontal width-50"
      *ngIf="selectedUser$ | async as user; else notUser"
      (ngSubmit)="onSave(user.userId)"
    >
      <!-- USER SELECTED -->
      <div style="margin-bottom: 15px">
        <h4>{{ user.userName }} ({{ user.userId }})</h4>
      </div>
      <!-- end USER SELECTED -->

      <!-- FIELD LOOP -->
      <div class="form-group" *ngFor="let settingItem of labelAndValues">
        <label class="col-sm-2 control-label" [for]="settingItem.key">{{
          settingItem.label
        }}</label>
        <div
          class="input-group"
          *ngIf="settingItem.key !== 'websiteLabel'; else webSiteField"
        >
          <div class="input-group-addon">https://</div>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="viewModelSettings[settingItem.key]"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <ng-template #webSiteField>
          <div class="col-sm-10 no-padding-left">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="viewModelSettings[settingItem.key]"
              [ngModelOptions]="{ standalone: true }"
            />
          </div>
        </ng-template>
      </div>
      <!-- end FIELD LOOP -->

      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10 no-padding-left">
          <button type="submit" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </form>
    <ng-template #notUser>
      <div *ngIf="!(loading$ | async)" class="text-centered">
        <h3>User Not Found (please select a user)</h3>
      </div>
      <div *ngIf="loading$ | async" class="text-center">
        <img src="img/loading.gif" />
      </div>
    </ng-template>
  </div>
</div>
